import { render, staticRenderFns } from "./OxFieldText.vue?vue&type=template&id=ed983018"
import script from "./OxFieldText.ts?vue&type=script&lang=ts&external"
export * from "./OxFieldText.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports